import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { LabeledMenuComponent, MenuItem } from '@mode/shared/ui';
import { daysOfTheMonthOptions } from './day-of-month.constant';

@Component({
  standalone: true,
  imports: [CommonModule, MatLegacyMenuModule, LabeledMenuComponent],
  selector: 'mode-day-of-month-selector',
  templateUrl: './day-of-month-selector.component.html',
  styleUrls: ['./day-of-month-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DayOfMonthSelectorComponent implements OnChanges {
  @Input() dayOfMonth = '1st';
  @Output() dayOfMonthChanged = new EventEmitter<number>();

  public daysOfTheMonth = daysOfTheMonthOptions;
  public selected: MenuItem | MenuItem[] | undefined = undefined;

  ngOnChanges(): void {
    this.setSelected(this.dayOfMonth);
  }
  setSelected(filter: string) {
    this.daysOfTheMonth.forEach((option) => {
      if (option.name === filter) {
        this.selected = option;
      }
    });
  }

  handleMenuChange(optionSelected: MenuItem) {
    const val = Number(optionSelected?.value);
    this.dayOfMonthChanged.emit(val);
  }
}
